const methodBgImages = document.querySelectorAll('.product_desc--bg-img, .product_method--bg-img');
if (methodBgImages) {
  methodBgImages.forEach(bgImage => {
    const img = new Image();
    const bgUrl = bgImage.style.backgroundImage.replace(/url\(['"]?(.*?)['"]?\)/i, '$1');

    img.src = bgUrl;
    img.onerror = function() {
      bgImage.style.display = 'none';
      bgImage.parentElement.style.display = 'none';
    };
  })
}

const detailMethodSwiper = document.querySelector('.product-details-method-swiper')
if (detailMethodSwiper) {
  new Swiper(detailMethodSwiper, {
    navigation: false
  })
}